import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { de_TranslateTextCommand, se_TranslateTextCommand } from "../protocols/Aws_json1_1";
export { $Command };
export class TranslateTextCommand extends $Command
    .classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("AWSShineFrontendService_20170701", "TranslateText", {})
    .n("TranslateClient", "TranslateTextCommand")
    .f(void 0, void 0)
    .ser(se_TranslateTextCommand)
    .de(de_TranslateTextCommand)
    .build() {
}
